import { render, staticRenderFns } from "./BuildingService.vue?vue&type=template&id=aad2be4e&scoped=true&"
import script from "./BuildingService.vue?vue&type=script&lang=ts&"
export * from "./BuildingService.vue?vue&type=script&lang=ts&"
import style0 from "./BuildingService.vue?vue&type=style&index=0&id=aad2be4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad2be4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aad2be4e')) {
      api.createRecord('aad2be4e', component.options)
    } else {
      api.reload('aad2be4e', component.options)
    }
    module.hot.accept("./BuildingService.vue?vue&type=template&id=aad2be4e&scoped=true&", function () {
      api.rerender('aad2be4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingService.vue"
export default component.exports